import * as Constants from '../constants/';

const initialState = {
  context: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.API_ERROR:
      return {
        ...state,
        error: action.error,
        context: action.context,
        timestamp: Date.now()
      };
    default:
      return state;
  }
}
